{
  "records": {
    "Opportunity": [
      {
        "Id": "006Qz0000c2d0b8AAA",
        "External_ID__c": "Opportunity_3f6c1d52-8a47-4e0b-9b1e-5c7a2d94e610",
        "Customer_ID__c": "VR23200808",
        "Deposit_Deposit__c": 65000,
        "interested_in_conveyancing__c": null,
        "Current_Property_Status__c": null,
        "Current_Property_Offer_Status__c": null,
        "Sale_price__c": null,
        "Mortgage_on_current_property__c": null
      }
    ],
    "Deposit_source__c": [],
    "Applicant__c": [
      {
        "Id": "a0AQz0000a25bf6AAA",
        "External_ID__c": "Applicant_b7e2c1a4-5d3f-4f60-9a8e-1c0d2e3f4a5b",
        "Marital_Status1_Applicant__c": null,
        "Occupancy_status__c": null,
        "Relationship_to_second_applicant__c": null
      }
    ],
    "Dependants__c": [],
    "Expenditure__c": [],
    "Income_Employment__c": [],
    "Property__c": [],
    "PropertyFlag__c": [],
    "PropertyFieldConfirmation__c": []
  },
  "failed": []
}
